<app-topbar></app-topbar>
<mat-sidenav-container class="sidebar-container">
  <mat-sidenav
    #sidenav
    mode="side"
    [(opened)]="opened"
    (opened)="events.push('open!')"
    (closed)="events.push('close!')"
  >
    <app-side-nav></app-side-nav>
  </mat-sidenav>
  <mat-sidenav-content class="sidebar-content">
    <!-- <header>CSP Portal</header> -->
    <mat-toolbar *ngIf="isUserLoggedIn" class="pl-1">
      <button
        mat-button
        (click)="sidenav.toggle()"
        *ngIf="isUserLoggedIn"
        class="icon-menu mr-2"
      >
        &#x2630;
      </button>
      <span style="margin-right: auto">CSP PORTAL</span>
      <span class="mr-5 font13"
        >Support :
        <a style="color: #7aceff" href="mailto:cspsupport@ilink-systems.com"
          >cspsupport@ilink-systems.com</a
        ></span
      >
      <span style="margin-right: 10px">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g id="Profile" transform="translate(-674 -731)">
            <rect
              id="Profile-2"
              data-name="Profile"
              width="24"
              height="24"
              rx="10"
              transform="translate(674 731)"
              fill="rgba(183,183,183,0.11)"
            />
            <g id="Layer_18" transform="translate(676.332 732.331)">
              <path
                id="Path_6613"
                data-name="Path 6613"
                d="M13.058,11.806a7.85,7.85,0,0,0-6.781,0A7.694,7.694,0,0,0,2,18.675a.767.767,0,0,0,.767.767h13.8a.767.767,0,0,0,.767-.767A7.694,7.694,0,0,0,13.058,11.806Z"
                transform="translate(0 -1.107)"
                fill="#7a7e81"
              />
              <g
                id="Layer_18-2"
                data-name="Layer_18"
                transform="translate(5.067 0.851)"
              >
                <path
                  id="Path_6613-2"
                  data-name="Path 6613"
                  d="M13.991,9.7a4.6,4.6,0,1,0-6.781,0C9.207,11.884,12.669,11.146,13.991,9.7Z"
                  transform="translate(-6 -2)"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </svg>
      </span>
      <div style="margin-left: 10px; margin-right: 10px">
        <span class="font13 pb-2">{{ Name }}</span>
      </div>
      <!-- <button mat-icon-button > -->
      <mat-icon [matMenuTriggerFor]="menu" style="cursor: pointer"
        >more_horiz</mat-icon
      >
      <!-- </button> -->
      <mat-menu #menu="matMenu" style="background-color: #2d2d2d">
        <button mat-menu-item *ngIf="isAdminUser">
          <mat-icon style="color: #fff"> email</mat-icon>
          <span class="font13" style="color: #fff">{{ Email }}</span>
        </button>
        <button mat-menu-item (click)="logout()" href="javascript:void(0)">
          <mat-icon style="color: #fff">save_alt</mat-icon>
          <span class="font13"><a style="color: #7aceff">Logout</a></span>
        </button>
      </mat-menu>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
